/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type NFLRedzoneAdvantagePageReceivingQueryVariables = {|
  teamIds?: ?$ReadOnlyArray<?string>,
  minTgt?: ?number,
  seasonID?: ?string,
|};
export type NFLRedzoneAdvantagePageReceivingQueryResponse = {|
  +nflRedzoneReceivingStats: ?$ReadOnlyArray<?{|
    +player: {|
      +firstName: string,
      +lastName: string,
      +position: {|
        +name: ?string
      |},
      +team: ?{|
        +logoSrc: ?string
      |},
    |},
    +targets: number,
    +receptions: number,
    +touchdowns: number,
  |}>
|};
export type NFLRedzoneAdvantagePageReceivingQuery = {|
  variables: NFLRedzoneAdvantagePageReceivingQueryVariables,
  response: NFLRedzoneAdvantagePageReceivingQueryResponse,
|};
*/


/*
query NFLRedzoneAdvantagePageReceivingQuery(
  $teamIds: [ID]
  $minTgt: Int
  $seasonID: ID
) {
  nflRedzoneReceivingStats(teamIds: $teamIds, minTgt: $minTgt, seasonId: $seasonID) {
    player {
      firstName
      lastName
      position {
        name
        id
      }
      team {
        logoSrc
        id
      }
      id
    }
    targets
    receptions
    touchdowns
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "minTgt"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "seasonID"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamIds"
},
v3 = [
  {
    "kind": "Variable",
    "name": "minTgt",
    "variableName": "minTgt"
  },
  {
    "kind": "Variable",
    "name": "seasonId",
    "variableName": "seasonID"
  },
  {
    "kind": "Variable",
    "name": "teamIds",
    "variableName": "teamIds"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoSrc",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "targets",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "receptions",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "touchdowns",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NFLRedzoneAdvantagePageReceivingQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "NFLRedzoneReceivingStatsType",
        "kind": "LinkedField",
        "name": "nflRedzoneReceivingStats",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatPlayerType",
            "kind": "LinkedField",
            "name": "player",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NFLStatPositionType",
                "kind": "LinkedField",
                "name": "position",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NFLStatTeamType",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": [
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "NFLRedzoneAdvantagePageReceivingQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "NFLRedzoneReceivingStatsType",
        "kind": "LinkedField",
        "name": "nflRedzoneReceivingStats",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatPlayerType",
            "kind": "LinkedField",
            "name": "player",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NFLStatPositionType",
                "kind": "LinkedField",
                "name": "position",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NFLStatTeamType",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1fc6a94e4d0e2ff51fca2658618484d0",
    "id": null,
    "metadata": {},
    "name": "NFLRedzoneAdvantagePageReceivingQuery",
    "operationKind": "query",
    "text": "query NFLRedzoneAdvantagePageReceivingQuery(\n  $teamIds: [ID]\n  $minTgt: Int\n  $seasonID: ID\n) {\n  nflRedzoneReceivingStats(teamIds: $teamIds, minTgt: $minTgt, seasonId: $seasonID) {\n    player {\n      firstName\n      lastName\n      position {\n        name\n        id\n      }\n      team {\n        logoSrc\n        id\n      }\n      id\n    }\n    targets\n    receptions\n    touchdowns\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '18046e7a6427188075d04f3fe39dace9';

module.exports = node;
